<template>
    <div
        class="navbar-container main-menu-content"
        :class="skin.includes('dark') ? 'navbar-header-dark' : 'navbar-header-light'"
    >
        <horizontal-nav-menu-items :items="navMenuItems" />
    </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'

import navMenuItems from '@/navigation/horizontal'

import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
    components: {
        HorizontalNavMenuItems,
    },
    setup() {
        const { skin } = useAppConfig()
        return { navMenuItems, skin }
    },
}
</script>

<style lang="scss">
@import '@resources/scss/base/core/menu/menu-types/horizontal-menu.scss';
</style>
